export default __webpack_public_path__ + "static/media/RedefinePassword.efea8e31.svg";